import React from 'react'

const SocialMobileLink = ({link, classObj, icon}) => {

      if(link.length === 0) return 

      return (
            <a href={link} className={`mobile_link ${classObj}`} target="_blank" rel="noreferrer">{icon}</a>
      )
}

export default SocialMobileLink
